import { Flex, Span, Input } from '@fareye/ui'
import React from 'react'
import { useTranslation } from '@fareye/common'
//NOTE: Child Listing Header
interface IHeader {
  label: string
  setTextData?(val: string): void
}
export function Header({ label, setTextData }: IHeader) {
  const { t } = useTranslation()
  return (
    <Flex p={7} alignItemsCenter justifyContentSpaceBetween>
      <Span variant="h6" style={{ color: 'black', fontWeight: '600' }}>
        {t(label)}
      </Span>
      {setTextData && (
        <Input
          placeholder={t('Type to filter data')}
          onChange={(ev: React.ChangeEvent<HTMLInputElement>) =>
            setTextData(ev.target.value)
          }
        />
      )}
    </Flex>
  )
}
